module.exports = __webpack_public_path__ + "502335a1781694ea9a15d943f99e5fdd.svg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../components/Footer/logos/fonds-soziokultur.svg
// module id = 940
// module chunks = 0